const ProductInstructionsLegacy = class extends HTMLElement {
  constructor () {
    super()

    this.headers = this.querySelectorAll('h3')
    this.photoWrappers = this.querySelectorAll('.photos')

    this.initHeaders()
    this.initPhotoWrappers()
  }

  /**
   * Reformats header elements
   * @returns if no photo wrappers exist
   */
  initHeaders () {
    if (this.headers.length < 1) { return }

    this.headers.forEach((header, index) => {
      const headerText = header.innerHTML
      const replacement = document.createElement('h3')

      replacement.classList.add('product-recipe__instructions-step-title')
      replacement.classList.add('heading')
      replacement.innerHTML = `
        <span class="product-recipe__instructions-step-number" aria-hidden="true">${index + 1}</span>
        ${headerText}
      `

      header.replaceWith(replacement)
    })
  }

  /**
   * Reformats photo wrappers with swiper structure
   * @returns if no photo wrappers exist
   */
  initPhotoWrappers () {
    if (this.photoWrappers.length < 1) { return }

    this.photoWrappers.forEach((photoWrapper, index) => {
      const photosInnerContent = photoWrapper.innerHTML

      photoWrapper.innerHTML = `
        <div class="product-recipe__instructions-step-images-main swiper" data-legacy-image-swiper="${index}">
          <div class="swiper-wrapper">
            ${photosInnerContent.replaceAll('<div>', '<div class="swiper-slide">')}
          </div>
          <div class="swiper-button-next">
            <img src="//cheesemaking.com/cdn/shop/t/83/assets/swiper-right.svg?v=77399738262728889481709746840" aria-hidden="true">
          </div>
          <div class="swiper-button-prev">
            <img src="//cheesemaking.com/cdn/shop/t/83/assets/swiper-left.svg?v=35173814241292093441709746840" aria-hidden="true">
          </div>
        </div>
      `

      this.initSwiper(`[data-legacy-image-swiper="${index}"]`)
    })
  }

  /**
   * Intilializes swiper
   * @param {String} sliderWrapper : query selector for slider wrapper
   */
  initSwiper (sliderWrapper) {
    const swiper = new Swiper(sliderWrapper, {
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      }
    })
  }
}

if (typeof window.customElements.get('product-instructions-legacy') === 'undefined') {
  window.customElements.define('product-instructions-legacy', ProductInstructionsLegacy)
}
